import { Badge, Card, Table, type Column } from "@helmr/ui";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { fetchMyCommission, type LedgerLine } from "../../api/commission";
import { useServices } from "../../app/services";
import { Empty, Field, Gate, PageHead, css as s, isMonth, useScope } from "./kit";

const PAGE = 200;
/** `/me/commission`: the caller's own lines. `total` and `held` are the API's figures over the whole filter, not the page. */
export function MyCommissionPage() {
  const sc = useScope();
  const { client } = useServices();
  const [month, setMonth] = useState("");
  const [limit, setLimit] = useState(PAGE);
  const ok = month === "" || isMonth(month);
  const q = useQuery({ queryKey: ["commission", "mine", month, limit, ...sc.scopeKey], queryFn: () => fetchMyCommission(client, { limit, ...(ok && month ? { month } : {}) }), retry: false, placeholderData: (p) => p });
  const cols: Array<Column<LedgerLine>> = [
    { key: "m", header: "Month", cell: (l) => l.periodMonth },
    { key: "basis", header: "Basis", cell: (l) => <span className={s.truncate} title={l.basis}>{l.basis}</span> },
    { key: "st", header: "Status", cell: (l) => <Badge tone={l.status === "held" ? "warn" : l.status === "reversed" ? "crit" : "ok"}>{l.status}</Badge> },
    { key: "amt", header: "Amount", align: "end", cell: (l) => <b className={s.num}>{sc.money(l.amount)}</b> },
  ];
  return (
    <div className={s.page}>
      <PageHead title="My commission" sub="What you have earned. Held amounts are paid once the sale is paid for." />
      <Card aria-label="My commission">
        <div className={s.tools}><Field label="Month" error={ok ? null : "Use YYYY-MM."}>{(a) => <input {...a} className={s.input} value={month} onChange={(e) => { setMonth(e.target.value); setLimit(PAGE); }} placeholder="YYYY-MM" />}</Field></div>
        <Gate query={q} what="your commission">
          {(d) => (
            <>
              <div className={s.strip}><div><small>Earned</small><b>{sc.money(d.total)}</b></div><div><small>Held</small><b>{sc.money(d.held)}</b></div></div>
              {d.lines.length === 0 ? <Empty icon="cash" title="No commission yet" description="Lines appear here as you earn them." /> : (
                <Table label="My commission lines" columns={cols} rows={d.lines} rowKey={(l) => l.id} minWidth={480} hasMore={d.lines.length >= limit && limit < 1000} onLoadMore={() => setLimit((n) => Math.min(1000, n + PAGE))} loadingMore={q.isFetching} />
              )}
            </>
          )}
        </Gate>
      </Card>
    </div>
  );
}
